import set from "set-value";
import get from "get-value";

export const setValue = (obj: any, path: string, value: any) => {
  set(obj, path, value);
  return obj;
}

export const getValue = (obj: any, path: string) => {
  let value = get(obj, path);
  return value;
}

export const filterArrayItems = (data: any, queryOptions: any) => {
  //USAGE:
  //    data: [],
  //    queryOptions: [{ search:'',
  //                     field:'' || fields: ['','']
  //                   }]

  let matches: any = [];

  //no filter defined so bail
  if (!queryOptions) {
    return data;
  }

  //loop through data items and searching for match in given field(s)
  for (let i = 0; i < data.length; i++) {
    let dataItem: any = data[i];
    let itemFound = false;

    for (let j = 0; j < queryOptions.length; j++) {
      let query = queryOptions[j]['search'];

      if (query) {
        query = query.toLowerCase();

        let found = false;
        //check for single or multiple fields
        let fields = queryOptions[j]['fields'] || [queryOptions[j]['field']];
        for (let k = 0; k < fields.length; k++) {
          let fieldName: any = fields[k];
          if (fieldName) {
            //any one field value matches
            if (dataItem[fieldName].toString().toLowerCase().indexOf(query) > -1) {
              found = true;
              break;
            }
          }
        }
        itemFound = found;
      }
      else {
        //if query empty or null, dataItem consider as match
        itemFound = true;
      }

      //any one query item fails, skip to next item
      if (!itemFound) { break; }
    }
    if (itemFound) {
      matches.push(dataItem);
    }
  }
  return matches;
}
